"use strict";

module.exports = {};
